import { useRequest } from 'ahooks'
import { Options } from 'ahooks/lib/useRequest/src/types'
// import { useGlobalLoading } from 'context/hooks/useGlobalLoading'
import { useLayoutEffect, useState } from 'react'

interface CustomOptions {
    globalLoading?: boolean
}

export const usePageRequest = <TData, TParams extends any[]>(
    service: (...args: TParams) => Promise<TData>,
    requestOptions?: Options<TData, TParams>,
    customOptions?: CustomOptions
) => {
    const [loading, setLoading] = useState(true);
    
    const needShowGlobalLoading = customOptions?.globalLoading !== false
    const result = useRequest(service, {
        ...requestOptions,
        onBefore: (...args) => {
            needShowGlobalLoading && setLoading(true)
            requestOptions?.onBefore?.(...args)
        },
        onFinally: (...args) => {
            needShowGlobalLoading && setLoading(false)
            requestOptions?.onFinally?.(...args)
        }
    })
    useLayoutEffect(() => {
        needShowGlobalLoading && !requestOptions?.manual && setLoading(result.loading)
    }, [needShowGlobalLoading, requestOptions?.manual, result.loading, setLoading])

    return result
}
